import { useState, useEffect } from "react";
import { getFirestore, doc, getDoc , getDocs, collection} from "firebase/firestore";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
import { app, db, storage } from "../../firebaseConfig";



const useAllPropertiesData = (titolo) => {
  const [propertiesData, setPropertiesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchPropertiesData = async () => {
      setLoading(true);
      try {
        if (titolo) {
          console.log(titolo);

          // Recupera un singolo documento basato sul titolo
          const sanitizedTitle = titolo.trim();

          // Prima prova a cercare con il titolo senza spazio
          let docRef = doc(db, "immobili", sanitizedTitle);
          let docSnap = await getDoc(docRef);

          // Se il documento non esiste, prova con il titolo che include uno spazio finale
          if (!docSnap.exists()) {
            const titleWithSpace = `${sanitizedTitle} `;
            console.log(titleWithSpace, "title check");
            docRef = doc(db, "immobili", titleWithSpace);
            console.log(docRef, "docref");
            docSnap = await getDoc(docRef);
            console.log(docSnap.data(), "docsnap");
          }

          if (docSnap.exists()) {
            const propertyData = docSnap.data();
            console.log(propertyData, "check");
            const imagesRef = ref(storage, `properties/${titolo}`);
            const imagesList = await listAll(imagesRef);
            const imageUrls = await Promise.all(
              imagesList.items.map((itemRef) => getDownloadURL(itemRef))
            );
            setPropertiesData([{ ...propertyData, photos: imageUrls }]);
          } else {
            setPropertiesData([]);
          }
        } else {
          // Recupera tutti i documenti dalla collezione "immobili"
          const querySnapshot = await getDocs(collection(db, "immobili"));
          const properties = [];

          for (const doc of querySnapshot.docs) {
            const propertyData = doc.data();
            const titolo = doc.id;
            const imagesRef = ref(storage, `properties/${titolo}`);
            const imagesList = await listAll(imagesRef);
            const imageUrls = await Promise.all(
              imagesList.items.map((itemRef) => getDownloadURL(itemRef))
            );
            properties.push({ ...propertyData, photos: imageUrls });
          }

          setPropertiesData(properties);
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchPropertiesData();
  }, [titolo]);
  console.log(propertiesData);
  return { propertiesData, loading, error };
};

export default useAllPropertiesData;


